import QuillEditor from "../../components/QuillEditor";

import { forwardRef, useEffect, useState, useImperativeHandle } from "react";
import {
  Button,
  FormGroup,
  Grid,
  Input,
  Label,
  TextArea,
} from "../../style/admin/Seo_Style";
import { ESeoResponse } from "../../models/seo";
import { useForm } from "react-hook-form";
import SeoService from "../../services/api/seo.service";
import { toast } from "../../utils/notify";
import { useLocation } from "react-router-dom";
import { Field } from "../../style/admin/settingform.style";
import TiptapEditor from "../../components/TipTapEditor";

interface SeoProps {
  seoProp: ESeoResponse | null;
  objId: string | null;
}
interface SeoRef {
  validate: () => Promise<boolean>;
  submit: () => Promise<void>;
}

const Seo = forwardRef<SeoRef, SeoProps>(({ seoProp, objId }, ref) => {
  const {
    control,
    register,
    handleSubmit,
    reset,
    trigger,

    formState: { errors },
  } = useForm<ESeoResponse>({
    defaultValues: {
      content: "",
    },
  });

  const [editorValue, setEditorValue] = useState(""); // ⭐ state riêng cho editor
  const [editorEnValue, setEditorEnValue] = useState(""); // ⭐ state riêng cho editor
  const [editorIdValue, setEditorIdValue] = useState(""); // ⭐ state riêng cho editor
  const [editorThValue, setEditorThValue] = useState(""); // ⭐ state riêng cho editor

  const [seo, setSeo] = useState<ESeoResponse>(); // ⭐ state riêng cho editor
  const location = useLocation();

  useEffect(() => {
    if (!objId) return;
    getSeo();
  }, [seoProp, objId]);

  const getSeo = async () => {
    if (!seoProp && !objId) return;

    reset({
      id: seoProp?.id,
      description: seoProp?.description,
      keywords: seoProp?.keywords,
      author: seoProp?.author,
      robots: seoProp?.robots,
      canonical: seoProp?.canonical,
      schema: seoProp?.schema,
      objId: objId ?? seoProp?.objId, // ⭐ QUAN TRỌNG
      noIndex: seoProp?.noIndex,
      og_type: seoProp?.og_type,
      og_site_name: seoProp?.og_site_name,
      og_title: seoProp?.og_title,
      og_description: seoProp?.og_description,
      og_image_width: seoProp?.og_image_width,
      og_image_height: seoProp?.og_image_height,
      og_url: seoProp?.og_url,
      og_image_alt: seoProp?.og_image_alt,
      og_locale: seoProp?.og_locale,

      twitter_card: seoProp?.twitter_card,
      twitter_title: seoProp?.twitter_title,
      twitter_description: seoProp?.twitter_description,
      twitter_image: seoProp?.twitter_image,

      viewport: seoProp?.viewport,
      theme_color: seoProp?.theme_color,
    });

    setEditorValue(seoProp?.content || "");
    setEditorEnValue(seoProp?.content_en || "");
    setEditorIdValue(seoProp?.content_indo || "");
    setEditorThValue(seoProp?.content_th || "");
  };

  useEffect(() => {
    getSeo();
  }, []);

  const onSubmit = async (data: ESeoResponse) => {
    if (!objId) {
      toast("Chưa có objId", "error");
      return;
    }

    const payload = {
      ...data,
      id: seoProp?.id, // ép lại
      objId,
      content: editorValue,
      content_en: editorEnValue,
    };

    if (data.schema) {
      try {
        JSON.parse(data.schema);
      } catch {
        toast("Schema JSON không hợp lệ", "error");
        return;
      }
    }

    if (seoProp?.id) {
      const res = await SeoService.updateSeo(payload);

      if (res.success) {
        // toast(res.message, "success");
        await reloadSeo(res.data);
      } else {
        toast(res.message, "error");
      }
    } else {
      const res = await SeoService.createSeo(payload);

      if (res.success) {
        // toast(res.message, "success");
        await reloadSeo(res.data);
      } else {
        toast(res.message, "error");
      }
    }
  };

  const reloadSeo = async (seo: ESeoResponse) => {
    if (seo) {
      reset({
        schema: seo?.schema,
        noIndex: seo?.noIndex,
        description: seo?.description,
        keywords: seo?.keywords,
        author: seo?.author,
        robots: seo?.robots,
        canonical: seo?.canonical,
        objId: seo?.objId,
        og_type: seo?.og_type,
        og_site_name: seo?.og_site_name,
        og_title: seo?.og_title,
        og_description: seo?.og_description,
        og_image_width: seo?.og_image_width,
        og_image_height: seo?.og_image_height,
        og_url: seo?.og_url,
        og_image_alt: seo?.og_image_alt,
        og_locale: seo?.og_locale,

        twitter_card: seo?.twitter_card,
        twitter_title: seo?.twitter_title,
        twitter_description: seo?.twitter_description,
        twitter_image: seo?.twitter_image,

        viewport: seo?.viewport,
        theme_color: seo?.theme_color,
      });

      // ⭐ đổ content cho Quill
      setEditorValue(seo?.content || "");
      setEditorEnValue(seo?.content_en || "");
    }
  };

  const submitForm = handleSubmit(onSubmit);

  useImperativeHandle(ref, () => ({
    submit: handleSubmit(onSubmit),
    validate: async () => {
      const isValid = await trigger();

      if (!isValid) {
        toast("Vui lòng kiểm tra lại dữ liệu SEO", "info");
      }

      return isValid;
    },
  }));

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormGroup
          sx={{
            display:
              seoProp?.objId === "1e96e902-e36c-43f5-8b40-5e6d66311cdb"
                ? "block"
                : "none",
          }}>
          <Label>Content VI</Label>
          <TiptapEditor
            value={editorValue}
            onChange={(val) => setEditorValue}
            height={700}></TiptapEditor>
          {/* <QuillEditor
            height={700}
            value={editorValue}
            onChange={setEditorValue}
          /> */}
        </FormGroup>

        <FormGroup
          sx={{
            display:
              seoProp?.objId === "1e96e902-e36c-43f5-8b40-5e6d66311cdb"
                ? "block"
                : "none",
          }}>
          <Label>Content EN</Label>
          <TiptapEditor
            value={editorEnValue}
            onChange={(val) => setEditorEnValue}
            height={700}></TiptapEditor>
          {/* <QuillEditor
            height={700}
            value={editorEnValue}
            onChange={setEditorEnValue}
          /> */}
        </FormGroup>

        <FormGroup
          sx={{
            display:
              seoProp?.objId === "1e96e902-e36c-43f5-8b40-5e6d66311cdb"
                ? "block"
                : "none",
          }}>
          <Label>Content Indo</Label>
          <TiptapEditor
            value={editorIdValue}
            onChange={(val) => setEditorIdValue}
            height={700}></TiptapEditor>
          {/* <QuillEditor
            height={700}
            value={editorEnValue}
            onChange={setEditorEnValue}
          /> */}
        </FormGroup>

        <FormGroup
          sx={{
            display:
              seoProp?.objId === "1e96e902-e36c-43f5-8b40-5e6d66311cdb"
                ? "block"
                : "none",
          }}>
          <Label>Content Thái lan</Label>
          <TiptapEditor
            value={editorThValue}
            onChange={(val) => setEditorThValue}
            height={700}></TiptapEditor>
          {/* <QuillEditor
            height={700}
            value={editorEnValue}
            onChange={setEditorEnValue}
          /> */}
        </FormGroup>

        <FormGroup>
          <Label>Schema</Label>
          <TextArea
            {...register("schema", {
              validate: (value) => {
                if (!value) return true;

                try {
                  const json = JSON.parse(value);

                  if (!json["@context"]) {
                    return "Schema thiếu @context";
                  }

                  if (!json["@type"]) {
                    return "Schema thiếu @type";
                  }

                  return true;
                } catch {
                  return "Schema phải là JSON hợp lệ";
                }
              },
            })}
            spellCheck={false}
            style={{
              fontFamily: "monospace",
              minHeight: 220,
              whiteSpace: "pre",
            }}
          />
          {errors.schema && (
            <small style={{ color: "red" }}>{errors.schema.message}</small>
          )}
        </FormGroup>

        <FormGroup>
          <Field style={{ marginTop: 16 }}>
            <Label>
              <input
                type="checkbox"
                {...register("noIndex")}
                style={{ marginRight: 8 }}
              />
              Noindex
            </Label>
          </Field>
        </FormGroup>

        {/* DESCRIPTION */}
        <FormGroup>
          <Label>Description</Label>
          <Input {...register("description")} />
        </FormGroup>

        <Grid>
          <FormGroup>
            <Label>Keywords</Label>
            <Input {...register("keywords")} />
          </FormGroup>

          <FormGroup>
            <Label>Author</Label>
            <Input {...register("author")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>Robots</Label>
            <Input {...register("robots")} />
          </FormGroup>

          <FormGroup>
            <Label>Canonical</Label>
            <Input {...register("canonical")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>OG Type</Label>
            <Input {...register("og_type")} />
          </FormGroup>

          <FormGroup>
            <Label>OG Site Name</Label>
            <Input {...register("og_site_name")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>OG Title</Label>
            <Input {...register("og_title")} />
          </FormGroup>

          <FormGroup>
            <Label>OG Description</Label>
            <Input {...register("og_description")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>OG Image Width</Label>
            <Input {...register("og_image_width")} />
          </FormGroup>

          <FormGroup>
            <Label>OG Image Height</Label>
            <Input {...register("og_image_height")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>OG Url</Label>
            <Input {...register("og_url")} />
          </FormGroup>

          <FormGroup>
            <Label>OG Image Alt</Label>
            <Input {...register("og_image_alt")} />
          </FormGroup>

          <FormGroup>
            <Label>OG Locale</Label>
            <Input {...register("og_locale")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>Twitter Card</Label>
            <Input {...register("twitter_card")} />
          </FormGroup>

          <FormGroup>
            <Label>Twitter Title</Label>
            <Input {...register("twitter_title")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>Twitter Description</Label>
            <Input {...register("twitter_description")} />
          </FormGroup>

          <FormGroup>
            <Label>Twitter Image</Label>
            <Input {...register("twitter_image")} />
          </FormGroup>
        </Grid>

        <Grid>
          <FormGroup>
            <Label>Viewport</Label>
            <Input {...register("viewport")} />
          </FormGroup>

          <FormGroup>
            <Label>Theme Color</Label>
            <Input {...register("theme_color")} />
          </FormGroup>
        </Grid>

        {/* <FormGroup>
        <Label>Content</Label>
        <QuillEditor height={400} value={content} onChange={setContent} />
      </FormGroup> */}

        {/* <div
          style={{
            marginTop: "15px",
            display: "flex",
            justifyContent: "start",
          }}>
          <Button type="submit">Cập nhật</Button>
        </div> */}
      </form>
    </>
  );
});

export default Seo;
